import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityDetailsService {

  @Output() stateFoundFromZipCode = new EventEmitter<string>();
  @Output() utilityShortNameChanged = new EventEmitter<string>();

  constructor() { }

  public stateFromZipCode(state: string) {
    this.stateFoundFromZipCode.emit(state);
  }

  public utilityShortName(utilityShortName: string) {
    this.utilityShortNameChanged.emit(utilityShortName);
  }
}
